import axios from 'axios'
import Qs from 'qs'
function getAllNews(fn){
    axios({
        method:'post',
        url:'https://www.yuchengprotect.com/getAllNews',
        data:Qs.stringify({
            
        }),
        headers:{'Content-Type':'application/x-www-form-urlencoded'}
    }).then((response) =>{          //这里使用了ES6的语法
        // console.log(response.data.data)
        fn(response.data.data)
        // _this.productImgList = response.data.data
    }).catch((error) =>{
        console.log(error)       //请求失败返回的数据
    })
}

function getNewsById(data,fn){
    axios({
        method:'post',
        url:'https://www.yuchengprotect.com/getNewsById',
        data:Qs.stringify({
            id:data.id
        }),
        headers:{'Content-Type':'application/x-www-form-urlencoded'}
    }).then((response) =>{          //这里使用了ES6的语法
        fn(response.data.data)
        // _this.productImgList = response.data.data
    }).catch((error) =>{
        console.log(error)       //请求失败返回的数据
    })
}


function newsNext(data,fn){
    axios({
        method:'post',
        url:'https://www.yuchengprotect.com/newsNext',
        data:Qs.stringify({
            id:data.id
        }),
        headers:{'Content-Type':'application/x-www-form-urlencoded'}
    }).then((response) =>{          //这里使用了ES6的语法
        fn(response.data.data)
        // _this.productImgList = response.data.data
    }).catch((error) =>{
        console.log(error)       //请求失败返回的数据
    })
}

function newsBefore(data,fn){
    axios({
        method:'post',
        url:'https://www.yuchengprotect.com/newsBefore',
        data:Qs.stringify({
            id:data.id
        }),
        headers:{'Content-Type':'application/x-www-form-urlencoded'}
    }).then((response) =>{          //这里使用了ES6的语法
        fn(response.data.data)
        // _this.productImgList = response.data.data
    }).catch((error) =>{
        console.log(error)       //请求失败返回的数据
    })
}
export {
    getAllNews,getNewsById,newsNext,newsBefore
}
